import { ApplicationState } from 'state/root.models'

export const root = ({ role }: ApplicationState) => role

export default root
